
import Vue from 'vue';

const tokenName = "access_token";
const refreshTokenName = "refresh_token";
const authType = "Bearer ";

const login = ({ token, refreshToken }) => {
    setTokenInLocalStorage({ token, refreshToken });
    setAxiosDefaultsHeadersCommonAuthorizationToken();
}

const logout = () => {
    deleteTokenInLocalStorage();
    deleteAxiosDefaultsHeadersCommonAuthorization();
}

const setTokenInLocalStorage = ({ token, refreshToken }) => {
    localStorage.setItem(tokenName, token);
    localStorage.setItem(refreshTokenName, refreshToken);
};

const deleteTokenInLocalStorage = () => {
    localStorage.removeItem(tokenName);
    localStorage.removeItem(refreshTokenName);
};

const getlocalStorageToken = () => {
    return localStorage.getItem(tokenName);
}

const getlocalStorageRefreshToken = () => {
    return localStorage.getItem(refreshTokenName);
}

const getBearerToken = () => {
    return authType + getlocalStorageToken();
}

const getBearerRefreshToken = () => {
    return authType + getlocalStorageRefreshToken();
}

const setAxiosDefaultsHeadersCommonAuthorizationToken = () => {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = getBearerToken();
}

const setAxiosDefaultsHeadersCommonAuthorizationRefreshToken = () => {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = getBearerRefreshToken();
}

const deleteAxiosDefaultsHeadersCommonAuthorization = () => {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = null;
}

export {
    tokenName,
    refreshTokenName,
    login,
    logout,
    setTokenInLocalStorage,
    deleteTokenInLocalStorage,
    getlocalStorageToken,
    getlocalStorageRefreshToken,
    getBearerToken,
    getBearerRefreshToken,
    setAxiosDefaultsHeadersCommonAuthorizationToken,
    setAxiosDefaultsHeadersCommonAuthorizationRefreshToken,
    deleteAxiosDefaultsHeadersCommonAuthorization,
}